import { ErrorKey } from "@inrev/common";
import { useFlags } from "@portal/providers/GlobalFlagsProvider";
import { type FC, useEffect } from "react";
import { errorMessageMap, isApiError } from "../../utils/error";

export type MutationErrorFlagProps = {
	errorHeading?: string;
	mutationError: Error | null;
	dismissError?: () => void;
};

export const MutationErrorFlag: FC<MutationErrorFlagProps> = ({
	errorHeading,
	mutationError,
	dismissError,
}) => {
	const { showErrorFlag } = useFlags();

	useEffect(() => {
		if (mutationError) {
			let message = mutationError.message;
			let heading = errorHeading;

			if (!errorHeading) {
				const { header, description } = isApiError(mutationError)
					? errorMessageMap[mutationError?.key || ErrorKey.default]
					: errorMessageMap.default;

				heading = header;
				message = description;
			}

			showErrorFlag({
				heading,
				message,
				onDismiss: dismissError,
			});
		}
	}, [showErrorFlag, mutationError, errorHeading, dismissError]);

	return null;
};
